import State from 'store/State';
import { selectWidgetInstancesState } from 'widgets/store/selectors';
import { WidgetType } from 'widgets/WidgetType';

export const selectObvTilesState = (state: State) =>
    selectWidgetInstancesState(state)[WidgetType.OBV_TILE];

export const selectObvTileState = (state: State, widgetKey: string) =>
    selectObvTilesState(state)[widgetKey];
